webpackJsonp([33],{

/***/ 1529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsStatistics_vue__ = __webpack_require__(1875);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d0e3e0e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsStatistics_vue__ = __webpack_require__(2251);
function injectStyle (ssrContext) {
  __webpack_require__(2241)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsStatistics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d0e3e0e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsStatistics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1875:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Settings_LogReasonTooltip_vue__ = __webpack_require__(2243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Settings_LoadcellTooltipCell_vue__ = __webpack_require__(2247);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['systemId', 'systemName'],
  provide: {
    grid: [__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["j" /* PdfExport */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["f" /* ExcelExport */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["d" /* DetailRow */]]
  },
  components: {
    LogReasonTooltip: __WEBPACK_IMPORTED_MODULE_4__components_Settings_LogReasonTooltip_vue__["a" /* default */]
  },
  data: function data() {
    return {
      data: [],
      pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
      toolbar: [{ text: this.$i18n.t('Statistics'), id: 'table-settings-title' }, { text: this.$i18n.t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right' }, { text: this.$i18n.t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export' }, { text: this.$i18n.t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export' }, { text: this.$i18n.t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export' }, 'Search'],
      childGrid: {
        queryString: "date",
        allowSorting: true,
        columns: [{ field: "unitNumber", headerText: this.$i18n.t('Device'), textAlign: "Left" }, { field: "TodayResult", headerText: this.$i18n.t('TodayResult'), textAlign: "Left", allowSorting: false }, { field: "WeekResult", headerText: this.$i18n.t('WeekResult'), textAlign: "Left", allowSorting: false }, { field: "CorrectPercent", headerText: this.$i18n.t('CorrectPercent'), textAlign: "Left" }, { field: "SyncTodayResult", headerText: this.$i18n.t('SyncTodayResult'), textAlign: "Left", allowSorting: false }, { field: "DlcRightErrorLogsCountResult", headerText: this.$i18n.t('DlcRight'), textAlign: "Left" }, { field: "DlcLeftErrorLogsCountResult", headerText: this.$i18n.t('DlcLeft'), textAlign: "Left" }, { field: "UnderMinOpenLevelTimeResult", headerText: this.$i18n.t('UnderMinOpenLevelTime'), textAlign: "Left", sortComparer: this.timeFormatSortComparer }, { field: "UnderAlarmLevelTimeResult", headerText: this.$i18n.t('UnderAlarmLevelTime'), textAlign: "Left", sortComparer: this.timeFormatSortComparer }, { field: "NoRapidLogTimeResult", headerText: this.$i18n.t('NoRapidLogTime'), textAlign: "Left", sortComparer: this.timeFormatSortComparer }, { field: "LoadCellErrorCodeResult", headerText: this.$i18n.t('LoadcellError'), textAlign: "Left", template: function template() {
            return {
              template: {
                extends: __WEBPACK_IMPORTED_MODULE_6__components_Settings_LoadcellTooltipCell_vue__["a" /* default */]
              }
            };
          }
        }]
      },
      wrapSettings: { wrapMode: "Content" },
      selectionOptions: { type: "Multiple" },
      filterOptions: {
        type: "Menu"
      },
      customAttributes: { class: 'customcss' },
      sortingModes: [],
      dateTimeFormatOptions: { format: 'yyyy-MM-dd', type: 'date' },
      LogReasonTemplate: function LogReasonTemplate() {
        return {
          template: {
            extends: __WEBPACK_IMPORTED_MODULE_4__components_Settings_LogReasonTooltip_vue__["a" /* default */]
          }
        };
      }
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var statistics7Days;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.data = [];
                _this.$emit('spin', true);

                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_2__api__["_64" /* getStatisticsForSystem */])(_this.systemId);

              case 4:
                statistics7Days = _context.sent;


                statistics7Days.forEach(function (s) {
                  s.errorLogsChecked = s.errorLogsCount + " / " + s.checkedLogsCount;
                  s.weightErrorLogsChecked = s.weightErrorLogsCount + " / " + s.checkedWeightLogsCount;
                });

                _this.data = statistics7Days;
                _this.$emit('spin', false);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    timeFormatSortComparer: function timeFormatSortComparer(ref, comp) {
      var r = this.valueFromTime(ref);
      var c = this.valueFromTime(comp);
      if (r < c) {
        return -1;
      } else if (r > c) {
        return 1;
      }
      return 0;
    },
    valueFromTime: function valueFromTime(el) {
      if (el == '-') {
        return 0;
      } else if (el.includes('s')) {
        refValue = el.replace('s', '');
        return parseInt(refValue);
      } else {
        var refSplit = el.replace('h', '').replace('min', '').split(' ');
        var r = (refSplit[0] * 60 + refSplit[1]) * 60;
        return r;
      }
    },

    toolbarClick: function toolbarClick(args) {
      switch (args.item.id) {
        case "table-system-title":
          this.$router.push({
            name: "systems"
          });
          break;
        case "table-settings-title":
          this.getData();
          break;
        case "pdf-export":
          this.$refs.grid.pdfExport();
          break;
        case "csv-export":
          this.$refs.grid.csvExport();
          break;
        case "excel-export":
          this.$refs.grid.excelExport();
          break;
        case 'clear-filters':
          this.$refs.grid.clearFiltering();
          break;
      }
    },
    dataBound: function dataBound() {
      this.$refs.grid.autoFitColumns();
    },
    onDetailDataBound: function onDetailDataBound(args) {
      Object(__WEBPACK_IMPORTED_MODULE_5__api_api__["_24" /* getDeviceStatisticsForSystem */])(this.systemId, args.data.date).then(function (response) {
        var dailyDeviceStatistics = response.data;

        dailyDeviceStatistics.forEach(function (d) {
          var correct = d.correctLogs + d.correctLogsWeekBefore;
          var total = d.totalLogs + d.totalLogsWeekBefore;
          var synccorrect = d.correctSyncLogs;
          var synctotallogs = d.totalSyncLogs;
          d.TodayResult = d.correctLogs + '/' + d.totalLogs;
          d.SyncTodayResult = d.correctSyncLogs + '/' + d.totalSyncLogs;
          d.WeekResult = correct + '/' + total;
          if (total) {
            d.CorrectPercent = (correct / total * 100).toFixed(2) + "%";
          } else {
            d.CorrectPercent = '-';
          }

          if (d.dlcRightErrorLogsCountWeekBefore == 0) {
            d.DlcRightErrorLogsCountResult = "-";
          } else {
            d.DlcRightErrorLogsCountResult = (d.dlcRightErrorLogsCount / d.dlcRightErrorLogsCountWeekBefore * 100).toFixed(2) + '%';
          }

          if (d.dlcLeftErrorLogsCountWeekBefore == 0) {
            d.DlcLeftErrorLogsCountResult = '-';
          } else {
            d.DlcLeftErrorLogsCountResult = '' + (d.dlcLeftErrorLogsCount / d.dlcLeftErrorLogsCountWeekBefore * 100).toFixed(2);
          }
          d.UnderMinOpenLevelTimeResult = '' + d.underMinOpenLevelTime.toAgoString();
          d.UnderAlarmLevelTimeResult = '' + d.underAlarmLevelTime.toAgoString();
          d.NoRapidLogTimeResult = '' + d.noRapidLogTime.toAgoString();
          d.LoadCellErrorCodeResult = '' + (d.loadCellErrorCode == 0 ? '-' : d.loadCellErrorCode);
        });

        dailyDeviceStatistics.sort(function (a, b) {
          return a.unitNumber - b.unitNumber;
        });

        args.detailElement.querySelector(".e-grid").ej2_instances[0].dataSource = dailyDeviceStatistics;
      });
    }
  },
  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getData();

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }()
});

/***/ }),

/***/ 1876:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            data: {}
        };
    },

    computed: {
        logsCount: function logsCount() {
            var result = "";
            result += this.$t('CrossReadingLogs') + (': ' + this.data.crossReadingLogsCount + '<br>') + this.$t('OtherTagInAntennaLogs') + (': ' + this.data.otherTagInAntennaLogsCount);
            return result;
        }
    }
});

/***/ }),

/***/ 1877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        text: function text() {
            return this.data[this.data.column.field];
        },
        tooltipText: function tooltipText() {
            var text = "";

            var errorCodeText = this.data.loadCellErrorCode.toString().replace('-', '').replace('9', '');
            errorCodeText = errorCodeText.padStart(3, "0");

            if (errorCodeText[0] == '2' && errorCodeText[1] == '0' && errorCodeText[2] == '4') {
                text += 'Error: Division by zero';
                return text;
            }

            switch (errorCodeText[0]) {
                case '0':
                    text += 'Error: No Connection<br/>';
                    break;
                case '1':
                    text += 'Error: ADC<br/>';
                    break;
                case '2':
                    text += 'Error: Incorrect Weight<br/>';
                    break;
            }

            switch (errorCodeText[1]) {
                case '0':
                    text += 'Dlc: Not Used<br/>';
                    break;
                case '1':
                case '2':
                case '3':
                    text += 'Dlc: ' + errorCodeText[1] + '<br/>';
                    break;
            }

            switch (errorCodeText[2]) {
                case '0':
                    text += 'Cell: Left';
                    break;
                case '1':
                    text += 'Cell: Right';
                    break;
            }

            return text;
        }
    },
    data: function data() {
        return {
            data: {}
        };
    }
});

/***/ }),

/***/ 2241:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2242);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("3c0699bb", content, true, {});

/***/ }),

/***/ 2242:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".tippy-tooltip.customTheme-theme{background-color:#346f8b}.tippy-popper[x-placement^=left] .tippy-tooltip.customTheme-theme .tippy-arrow{border-left:8px solid #346f8b}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/System/SettingsStatistics.vue"],"names":[],"mappings":"AACA,iCACE,wBAA0B,CAC3B,AACD,+EACE,6BAA+B,CAChC","file":"SettingsStatistics.vue","sourcesContent":["\n.tippy-tooltip.customTheme-theme {\n  background-color: #346F8B;\n}\n.tippy-popper[x-placement^='left'] .tippy-tooltip.customTheme-theme .tippy-arrow {\n  border-left: 8px solid #346F8B;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogReasonTooltip_vue__ = __webpack_require__(1876);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dffeb518_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogReasonTooltip_vue__ = __webpack_require__(2246);
function injectStyle (ssrContext) {
  __webpack_require__(2244)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dffeb518"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogReasonTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dffeb518_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogReasonTooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2244:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2245);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("c10d34c4", content, true, {});

/***/ }),

/***/ 2245:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"LogReasonTooltip.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({ theme : 'customTheme', placement : 'left', arrow : true }),expression:"{ theme : 'customTheme', placement : 'left', arrow : true }"}],attrs:{"content":_vm.logsCount}},[_vm._v("\n"+_vm._s(_vm.data.otherReasonLogsCount)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadcellTooltipCell_vue__ = __webpack_require__(1877);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d59be1b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadcellTooltipCell_vue__ = __webpack_require__(2250);
function injectStyle (ssrContext) {
  __webpack_require__(2248)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadcellTooltipCell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d59be1b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadcellTooltipCell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2248:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2249);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("3f06ec34", content, true, {});

/***/ }),

/***/ 2249:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"LoadcellTooltipCell.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{directives:[{name:"tippy",rawName:"v-tippy",value:({theme : 'customTheme', placement: 'left', size: 'large'}),expression:"{theme : 'customTheme', placement: 'left', size: 'large'}"}],attrs:{"content":_vm.tooltipText}},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","min-width":"1280px","padding":"10px"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","flex":"1","height":"100%","min-width":"1280px"}},[_c('ejs-grid',{ref:"grid",attrs:{"height":"100%","width":"100%","toolbar":_vm.toolbar,"toolbarClick":_vm.toolbarClick,"selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.data,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"allowPdfExport":true,"allowCsvExport":true,"allowExcelExport":true,"showBusyIndicator":true,"childGrid":_vm.childGrid,"detailDataBound":_vm.onDetailDataBound}},[_c('e-columns',[_c('e-column',{attrs:{"field":"date","headerText":_vm.$t('Date'),"textAlign":"Left","customAttributes":_vm.customAttributes,"type":"date","format":_vm.dateTimeFormatOptions}}),_vm._v(" "),_c('e-column',{attrs:{"field":"logsCount","headerText":_vm.$t('Logs'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"weightLogsCount","headerText":_vm.$t('WeightLogsCount'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"unknownWeightLogsCount","headerText":_vm.$t('UnknownAnimalWeightLogsCount'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"errorLogsChecked","headerText":_vm.$t('ErrorLogsChecked'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"weightErrorLogsChecked","headerText":_vm.$t('WeightErrorLogsChecked'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"otherReasonLogsCount","headerText":_vm.$t('OtherReasonLogs'),"template":_vm.LogReasonTemplate,"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"ghostAnimalsCount","headerText":_vm.$t('GhostAnimals'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"unknownAnimalsCount","headerText":_vm.$t('UnknownAnimals'),"textAlign":"Left","customAttributes":_vm.customAttributes}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/33.1d272dc3f70e3a99db85.js